import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex min-h-[80vh] items-center justify-center bg-white px-6 pt-24" data-testid="notfound-page">
      <div className="text-center">
        <p className="bg-[linear-gradient(100deg,#00C6CC,#2FCB74)] bg-clip-text text-7xl font-extrabold text-transparent md:text-8xl">
          404
        </p>
        <h1 className="mt-4 text-2xl font-bold text-ink md:text-3xl">
          Cette page n'existe pas.
        </h1>
        <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-ink/60">
          Le lien est peut-être erroné ou la page a été déplacée. Revenez à
          l'accueil pour découvrir Syndicappli360.
        </p>
        <Link
          to="/"
          data-testid="notfound-home-button"
          className="mt-8 inline-flex items-center gap-2.5 rounded-full bg-[linear-gradient(100deg,#00C6CC,#2FCB74)] px-8 py-4 text-sm font-bold text-white shadow-[0_15px_35px_-12px_rgba(0,190,200,0.6)] transition-transform duration-300 hover:scale-105 active:scale-95"
        >
          Retour à l'accueil
        </Link>
      </div>
    </div>
  );
}
